(() => {
  'use strict';
  const KEY = 'BosscoLandingSku';
  if (window[KEY]) { window[KEY].scan(); return; }
  const records = new Map();
  let jqueryBound = false;

  function nativeForm(productId) {
    const forms = Array.from(document.querySelectorAll('[data-section-type="main-product"] .product-form'))
      .filter(form => form.dataset.productId === productId);
    return forms.find(form => !form.closest('[data-bc-native-purchase-source]')) || forms[0];
  }
  function render(record, variant) {
    const sku = String(variant?.sku || '').trim();
    if (record.value.textContent !== sku) record.value.textContent = sku;
    record.node.hidden = !sku;
  }
  function sync(record) {
    const input = nativeForm(record.productId)?.querySelector('[name="id"]') ||
      record.panel.querySelector('[data-bc-variant]');
    const id = input ? input.value : record.node.dataset.bcHeroSkuVariant;
    render(record, record.variants.find(variant => String(variant.id) === String(id)));
  }
  function updateFromForm(form, variant) {
    if (!form?.closest('[data-section-type="main-product"]')) return;
    for (const record of records.values()) {
      if (record.node.isConnected && record.productId === form.dataset.productId &&
          nativeForm(record.productId) === form) render(record, variant);
    }
  }
  function bindModeEvents() {
    if (jqueryBound || !window.jQuery) return;
    jqueryBound = true;
    // Mode emits this after its own option, price and SKU updates, including
    // first-run setup and the native fallback used when main-product is off.
    window.jQuery(document).on('variantChanged.bcLandingSku', '.product-form', function (_event, variant) {
      updateFromForm(this, variant);
    });
  }
  function scan() {
    bindModeEvents();
    for (const node of records.keys()) if (!node.isConnected) records.delete(node);
    document.querySelectorAll('[data-bc-hero-sku]').forEach(node => {
      if (!records.has(node)) {
        const panel = node.closest('[data-bc-purchase]');
        const value = node.querySelector('[data-bc-hero-sku-value]');
        if (!panel || !value) return;
        try {
          const variants = JSON.parse(panel.querySelector('[data-bc-variants]').textContent);
          records.set(node, { node, value, panel, variants, productId: node.dataset.productId || panel.dataset.productId });
        } catch { return; }
      }
      sync(records.get(node));
    });
  }
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const form = target.closest('.product-form');
    const panel = target.closest('[data-bc-purchase]');
    if (!form && !panel) return;
    queueMicrotask(() => {
      if (target.name === 'id' && event.detail && 'variant' in event.detail) {
        updateFromForm(form, event.detail.variant);
        return;
      }
      for (const record of records.values()) {
        if (record.node.isConnected && (record.panel === panel ||
            form?.dataset.productId === record.productId)) sync(record);
      }
    });
  });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type => {
    document.addEventListener(type, () => setTimeout(scan, 0));
  });
  document.addEventListener('DOMContentLoaded', scan, { once: true });
  window.addEventListener('load', scan, { once: true });
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLScriptElement && /jquery|theme\.js/.test(event.target.src)) scan();
  }, true);
  window[KEY] = { scan };
  scan();
})();
